// i18n area 'common' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.cs-CZ.meta.json.
import type { enUS } from './common'

export const csCZ: typeof enUS = {
  nav: {
    home: 'Domů',
    vms: 'Virtuální stroje',
    templates: 'Šablony',
    importVms: 'Import VM',
    containers: 'Kontejnery',
    containersApps: 'Aplikace',
    containersPods: 'Pody',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Obrazy OCI',
    containersOciRegistries: 'Registry OCI',
    containersCtTemplates: 'Šablony CT',
    networkServices: 'Síťové služby',
    firewall: 'Firewall',
    checkpoints: 'Checkpointy',
    backup: 'Zálohování',
    monitoring: 'Monitorování',
    cluster: 'Klastr',
    clusterSettings: 'Globální nastavení',
    clusterNodes: 'Uzly',
    clusterDevices: 'Prostředky USB a PCIe',
    clusterFederation: 'Federace',
    network: 'Síť',
    overlayNetworks: 'Overlay sítě',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Úložiště',
    data: 'Data',
    storages: 'Úložiště',
    hci: 'Hyperkonvergence',
    ceph: 'Ceph',
    system: 'Systém',
    tasks: 'Úlohy',
    events: 'Události',
    audit: 'Audit',
    diagnostics: 'Diagnostika',
    notifications: 'Oznámení',
    proximity: 'TVirt Proximity',
    users: 'Uživatelé a skupiny',
    groups: 'Skupiny',
    mfa: 'MFA',
    realms: 'Realmy a SSO',
    rbac: 'Role a oprávnění',
    credentials: 'Přihlašovací údaje',
    scopes: 'Scopy',
    tags: 'Tagy',
    explorer: 'Prozkoumat',
    licensing: 'Licence',
    information: 'Informace'
  },
  mode: {
    light: 'Světlý',
    dark: 'Tmavý',
    system: 'Systém',
    tooltip: 'Motiv'
  },
  language: {
    tooltip: 'Jazyk'
  },
  langRegion: {
    europe: 'Evropa',
    northAmerica: 'Severní Amerika',
    southAmerica: 'Jižní Amerika',
    asia: 'Asie'
  },
  notFound: {
    title: 'Stránka nenalezena',
    body: 'Tato adresa neodpovídá žádné stránce TVirt — mohla se přesunout s aktualizací, nebo je odkaz zastaralý.',
    backHome: 'Zpět na Domů'
  },
  scopeBrowser: {
    title: 'Scopy',
    all: 'Celý klastr',
    noChildren: 'Žádné pod-scopy zde',
    recursive: 'Zahrnout potomky',
    collapse: 'Sbalit panel scopů',
    openPicker: 'Procházet scopy',
    up: 'O úroveň výš',
    countTooltip: '{direct} v tomto scopu · {total} včetně potomků'
  },
  search: {
    tooltip: 'Hledat (⌘K)',
    placeholder: 'Hledat VM, sítě, úložiště…',
    empty: 'Žádné výsledky',

    // Kolo command palette (#221, ratifikováno 2026-08-06): hlavičky skupin,
    // typy mimo census exploreru, slovník kláves a slovesa skupiny Akce.
    groups: {
      recent: 'Nedávné',
      shortcuts: 'Zkratky',
      actions: 'Akce',
      goTo: 'Přejít na'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Uzel'
    },
    footer: {
      navigate: 'procházet',
      open: 'otevřít',
      close: 'zavřít'
    },
    actions: {
      createVm: 'Vytvořit VM…',
      uploadIso: 'Nahrát ISO…',
      clusterSettings: 'Nastavení klastru',
      consoleOf: 'Přejít na konzoli {name}'
    }
  },
  stub: {
    containersSummary: 'Aplikace a systémové kontejnery (CT) s jejich obrazy OCI, registry a šablonami — spravované vedle vašich VM.',
    sectionSummary_vms: 'Virtuální stroje a jejich šablony — životní cyklus, snímky, migrace a konzole.',
    sectionSummary_storages: 'Úložiště, kde žijí disky, obrazy a metadata VM.',
    sectionSummary_catalogs: 'Domov souborových artefaktů klastru: obrazy ISO, šablony CT a VM a archivy OCI, uspořádané v katalozích.',
    sectionSummary_overlay: 'Overlay sítě VXLAN mezi uzly klastru.',
    sectionSummary_fabric: 'Inventář fyzické sítě — přepínače, porty, LAGG a logické sítě.',
    sectionSummary_ipam: 'Adresace odvozená ze sítí fabric a overlay: kdo drží každou adresu.',
    sectionSummary_services: 'Servery DHCP a DNS odvozené ze síťové evidence.',
    sectionSummary_ceph: 'Spravované klastry Ceph na uzlech TVirt.',
    sectionSummary_hci: 'Hyperkonvergované úložné technologie na uzlech TVirt.',
    sectionSummary_cluster: 'Uzly, členství a nastavení klastru.',
    containers: 'Systémové kontejnery jsou na roadmapě — tato sekce je bude hostit.',
    containersApps: 'Kontejnerizované aplikace jsou na roadmapě — tato oblast je bude hostit.',
    containersPods: 'Pody sdružují kontejnery sdílející síť a svazky — instance jsou aplikace.',
    containersCt: 'Systémové kontejnery (CT) jsou na roadmapě — tato oblast je bude hostit.',
    multiscsi: 'TVStor MultiSCSI je na roadmapě — tato oblast ho bude hostit.',
    clusterFederation: 'Federace mezi klastry TVirt je na roadmapě — tato oblast ji bude hostit.',
    containersOciImages: 'Obrazy OCI jsou na roadmapě — tato oblast je bude hostit.',
    containersOciRegistries: 'Registry OCI jsou na roadmapě — tato oblast je bude hostit.',
    containersCtTemplates: 'Šablony CT jsou na roadmapě — tato oblast je bude hostit.',
    importVms: 'Zde přistanou importéry ESXi a Proxmox: konverze hostů a hromadná migrace do TVirt.',
    backup: 'Integrované zálohování přichází s verzí 6.2: deduplikované content-addressed repozitáře, inkrementy CBT, okna neměnnosti a replikace repo-to-repo.',
    monitoring: 'Dashboardy kontence pro celý klastr (cpu.ready, tlak PSI, vestavěné výstrahy) se chystají — dnes tytéž metriky žijí v detailech každé VM.'
  },
  home: {
    welcome: 'Jste přihlášeni jako: {name}',
    subtitle: 'Zde je váš klastr TVirt na jeden pohled.',
    loadError: 'Přehled se nepodařilo načíst — je backend TVirt dostupný?',
    health: {
      ok: 'Vše v pořádku',
      warning: 'Vyžaduje pozornost',
      critical: 'Kritické problémy'
    },
    reason: {
      'node-down': '{subject} je vypnutý',
      'node-stale': '{subject} se už nějakou dobu neozývá',
      'node-maintenance': '{subject} v údržbě',
      'tasks-failed': {
        one: '{n} selhaná úloha za posledních 24h',
        few: '{n} selhané úlohy za posledních 24h',
        many: '{n} selhané úlohy za posledních 24h',
        other: '{n} selhaných úloh za posledních 24h'
      },
      'storage-degraded': 'úložiště {subject} je degradované',
      'storage-error': 'úložiště {subject} je v chybovém stavu',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store klastru je nedostupný',
      'license-absent': 'žádná licence — nové VM se nemohou spustit',
      'license-expired': 'licence vypršela — nové VM se nemohou spustit',
      'license-exceeded': 'limit licence překročen — nové VM se nemohou spustit',
      'failover-reserve-eroded': 'rezerva pro failover je téměř spotřebovaná',
      'failover-reserve-exhausted': 'rezerva pro failover je vyčerpaná — nové VM se nemohou spustit',

      'oci-cache-nearly-full': 'mezipaměť OCI na {subject} je téměř plná — digesty se vyřazují ručně',
      'oci-cache-full': 'mezipaměť OCI na {subject} je plná — žádný pull neuspěje, dokud nevyřadíte digesty',
      'config-replica-empty': 'replika konfigurace na {subject} je PRÁZDNÁ — uzel nemá konfiguraci clusteru, dokud replikace neuspěje',
      'config-replica-stalled': 'replikace konfigurace na {subject} stojí — místní kopie zaostává za konfigurací clusteru'
    },
    staleChip: 'Data nejsou aktuální',
    staleAsOf: 'poslední replikace {time}',
    zone: {
      nodes: 'Uzly',
      failoverReserve: 'Rezerva pro failover',
      capacity: 'Kapacita',
      workload: 'Pracovní zátěž',
      protection: 'Ochrana',
      activity: 'Nedávná aktivita'
    },

    // Zóna rezervy pro failover (admission control N+1, úloha #133b).
    reserve: {
      state: {
        ok: 'Rezerva neporušená',
        eroded: 'Rezerva téměř spotřebovaná',
        exhausted: 'Rezerva vyčerpaná',
        unknown: 'Rezerva neznámá'
      },
      tolerate: {
        one: 'toleruje ztrátu {n} uzlu',
        few: 'toleruje ztrátu {n} uzlů',
        many: 'toleruje ztrátu {n} uzlu',
        other: 'toleruje ztrátu {n} uzlů'
      },
      usedOf: '{used} / {allowed} GiB v použití',
      keepFree: '{n} GiB ponecháno volných pro failover',
      expendable: 'z toho {n} postradatelných za provozu',
      headroom: 'lze ještě spustit {n} GiB',
      short: 'rezervě chybí {n} GiB — nové VM se nemohou spustit',

      // Obrovské stránky podle velikosti (ratifikováno 2026-08-04) — forma
      // «popisek: {n}» záměrně: žádný jazyk nemusí skloňovat po proměnném čísle.
      hp: {
        usedOf: 'Stránky o velikosti {size} — v použití: {used} / {allowed}',
        keepFree: 'ponecháno volných pro failover: {keep}',
        headroom: 'lze ještě spustit: {n}',
        short: 'v rezervě chybí: {n} — nové VM s obrovskými stránkami se nemohou spustit'
      },
      worstCase: 'nejhorší případ: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Žádný uzel zatím nenahlásil svou paměť — rezervu nelze spočítat a žádné spuštění se neodmítá.',
      reason: {
        attestedDown: 'prohlášen za vypnutý',
        maintenance: 'v údržbě',
        unreachable: 'nedostupný',
        capacityUnknown: 'paměť nenahlášena'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: 'jádra: {cores} / vlákna: {threads}',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktivní VM',
        few: '{n} aktivní VM',
        many: '{n} aktivní VM',
        other: '{n} aktivních VM'
      },
      activeVmsUnknown: 'počet aktivních VM neznámý',
      lastSeen: 'viděn {time}',
      neverSeen: 'nikdy neviděn',
      down: 'Vypnutý',
      maintenance: 'Údržba',
      stale: 'Nedostupný'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisionováno',
      reserve: 'rezerva {n} GiB',
      unobserved: 'kapacita zatím nepozorována',
      empty: 'Zatím žádné úložiště'
    },
    workload: {
      vms: 'Virtuální stroje',
      apps: 'Aplikace',
      services: 'Síťové služby',
      empty: 'Zatím nic',
      phasesUnknown: 'rozdělení podle fází není k dispozici'
    },
    protection: {
      none: 'Zatím není nakonfigurován žádný cíl záloh — chraňte svou konfiguraci.',
      configure: 'Nakonfigurovat checkpointy',
      noRuns: 'Zatím nebyl vytvořen žádný checkpoint.',
      last: 'Poslední checkpoint',
      onTarget: 'na {target}',
      viewAll: 'Checkpointy'
    },
    activity: {
      empty: 'Žádná nedávná aktivita',
      failed24: {
        one: '{n} selhaná za 24h',
        few: '{n} selhané za 24h',
        many: '{n} selhané za 24h',
        other: '{n} selhaných za 24h'
      },
      viewAll: 'Zobrazit všechny úlohy'
    }
  },
  notes: {
    title: 'Poznámky',
    tabEdit: 'Upravit',
    tabPreview: 'Náhled',
    placeholder: 'Volné poznámky operátora — Markdown se vykresluje v náhledu',
    empty: 'Žádné poznámky',
    tooLarge: 'Poznámky překračují limit 64 KiB',
    saveError: 'Poznámky se nepodařilo uložit'
  },
  common: {

    // Kolo «poctivé chyby» (2026-08-03): odpověď 200, kterou tento klient
    // neumí přečíst, NENÍ spadlá síť — obviňování backendu posílá operátora
    // zkoumat službu, která funguje (bug hunt #157, U1).
    contractError: 'Odpověď backendu obsahuje hodnotu, kterou toto rozhraní nezná: {field}={value} — aktualizujte webui na verzi backendu.',
    contractErrorItems: 'Objekty tohoto seznamu nečitelné pro toto rozhraní ({field}={value}) se nezobrazují — počet: {count}.',
    staleHint: 'Store je nedostupný — zobrazuje se replika konfigurace tohoto uzlu; stav flotily je neznámý.',
    staleStateAge: 'stav k {time}',
    staleStateNever: 'stav nebyl ze store nikdy přijat: vidíte jen pozorování tohoto uzlu',
    staleStateTooltip: 'Store clusteru je nedostupný: pozorovaný stav (fáze, uzel, agent) pochází z repliky stavu tohoto uzlu a odpovídá poslednímu úspěšnému čtení ze store — může být zastaralý.',
    noPermission: 'Nemáte oprávnění k této akci',

    // Vypršelý rozpočet čekání NENÍ výsledek (Luca 2026-08-06): stopky
    // klienta měří trpělivost klienta, ne stav serveru — hlášení říká «stále
    // běží», nikdy «nezdařila se».
    actionStillRunning: 'Akce stále běží — výsledek zatím není znám',
    staleWrite: 'Někdo jiný tento objekt změnil, zatímco jste jej upravovali — nic nebylo zapsáno. Načtěte znovu a zopakujte úpravu na aktuálním stavu.',
    staleReload: 'Znovu načíst',
    preview: 'Náhled',
    previewTitle: 'Náhled výsledku',
    previewNothingWritten: 'Simulováno na serveru — nic nebylo zapsáno.',
    previewChanged: 'Zvýrazněny jsou hodnoty, které by se změnily.'
  },
  context: {
    copySelection: 'Kopírovat vybraný text'
  },
  crud: {
    create: 'Vytvořit',
    viewDetails: 'Zobrazit detaily',
    viewOrEdit: 'Zobrazit nebo upravit',
    selected: 'vybráno',
    viewUsingVms: 'Zobrazit VM, které tento prostředek používají',
    clearSelection: 'Zrušit výběr',
    deleteSelected: 'Odstranit vybrané',
    bulkConfirmBody: {
      one: 'Odstranit {count} vybranou položku? Pokud je chráněná, bude nahlášena a ponechána.',
      few: 'Odstranit {count} vybrané položky? Ty chráněné budou nahlášeny a ponechány.',
      many: 'Odstranit {count} vybrané položky? Ty chráněné budou nahlášeny a ponechány.',
      other: 'Odstranit {count} vybraných položek? Ty chráněné budou nahlášeny a ponechány.'
    },
    bulkDeleted: 'odstraněno',
    bulkRefused: 'odmítnuto',
    fieldId: 'ID',
    createdAt: 'Vytvořeno',
    updatedAt: 'Aktualizováno',
    immutableField: 'Zafixováno při vytvoření — contract změnu nedovoluje',
    immutableScope: 'Scope se přiřazuje při vytvoření; některé prostředky se přesouvají vyhrazenou akcí',
    observedField: 'Pozorovaný stav — hlášený platformou, nelze upravovat'
  }
}
